'use client';

import { PrismicRichText } from '@prismicio/react';
import { type RichTextField } from '@prismicio/client';

import {
  BaselineConfiguration,
  useRetainableSearchParamsContext,
} from '@preventx/prismic-services';

// Services
import { applicationEnv } from '@/services/env/shared';

// Components
import { List } from '@preventx/oxygen';

type RichTextSimpleFeaturesProps = {
  content: RichTextField;
};

export const RichTextSimpleFeatures = ({
  content,
}: RichTextSimpleFeaturesProps) => {
  const { searchParams } = useRetainableSearchParamsContext();

  const { WebsiteUrl } = applicationEnv();

  const configuration = BaselineConfiguration({
    websiteUrl: WebsiteUrl,
    searchParams: searchParams,
  });

  return (
    <PrismicRichText
      field={content}
      components={{
        ...configuration,
        list: ({ children }) => (
          <List component="ul" className="t-left">
            {children}
          </List>
        ),
      }}
    />
  );
};
